<template>
    <div class="layout-menu-container">
        <div class="text-center">
            <div class="shoptok-logo mb-5" alt=""></div>
            <img
                v-if="selectedShop && selectedShop.logo_url && user.level >= 3"
                :src="
                    selectedShop.image_name
                        ? 'https://img.ep-cdn.com/images/160/48/' +
                          selectedShop.image_name.substr(0, 2) +
                          '/' +
                          selectedShop.image_name +
                          '.webp'
                        : null
                "
                class="mb-1 menu-shop-logo"
                alt="Shop logo"
            />

        </div>
        <div class="text-center mt-2 mb-2">
            <span v-if="selectedShop">
                @
                <template v-if="selectedShop.country_locale_code == 'rs'">ePonuda.com</template>
                <template v-if="selectedShop.country_locale_code == 'si'">Shoptok.si</template>
                <template v-if="selectedShop.country_locale_code == 'hr'">Shoptok.hr</template>
                <template v-if="selectedShop.country_locale_code == 'ba'">ePonuda.ba</template>
            </span>
        </div>
        <Dropdown
            v-if="shops && user.level >= 3"
            v-model="selectedShop"
            :options="getShops"
            optionLabel="name"
            optionGroupLabel="country"
            optionGroupChildren="items"
            dataKey="id"
            placeholder="Izaberite prodavnicu"
            filter
            class="menu-shop-dropdown w-full mb-4"
            @hide="hideMenu"
            ref="search"
            :disabled="shops?.length === 1"
        >
            <template #optiongroup="slotProps">
                <div class="flex">
                    <div>{{ slotProps.option.country }}</div>
                </div>
            </template>
        </Dropdown>
        <AppPanelMenu :exact="false" :model="items" v-model:expandedKeys="expandedKeys" />
    </div>
</template>

<script>
import AppPanelMenu from "./AppPanelMenu";
import useHelpers from "@/composables/helpers";
import { ref, onMounted, computed, watch } from "vue";
import { storeToRefs } from "pinia";
import { useI18n } from "vue-i18n";
import { useShopStore } from "../../store/shop";
import { useUserStore } from "../../store/user";
import { useRoute } from "vue-router";

export default {
    name: "AppMenu",
    components: {
        AppPanelMenu,
    },
    setup() {
        const { t } = useI18n();
        const userStore = useUserStore();
        const shopStore = useShopStore();
        const expandedKeys = ref({});
        const { user } = storeToRefs(userStore);
        const { shops, selectedShop, getShops, source } = storeToRefs(shopStore);
        const { fetchClicksDataByReport, fetchTableDataByReport, fetchData, createUserPageLog } = useHelpers();
        const search = ref(null);
        const route = useRoute();

        onMounted(async () => {
            for (let item of items.value) {
                expandedKeys.value[item.key] = true;
            }
            expandedKeys.value[1] = true;
        });

        const items = computed(() => {
            let menuItems = [
                {
                    key: 17,
                    label: t("components.common.appMenu.growth"),
                    icon: "pi pi-fw pi-chart-line",
                    items: [
                        {
                            key: "0_0",
                            label: t("components.common.appMenu.growthFormula"),
                            to: "/growth-formula",
                        },
                        {
                            key: "0_1",
                            label: t("components.common.appMenu.trustOk"),
                            to: "/trust-ok",
                        },
                    ],
                },
            ];

            if (userStore.user.level >= 3 && userStore.user.confirmed) {
                menuItems.push(
                    {
                        key: 0,
                        label: t("components.common.appMenu.analytics"),
                        icon: "pi pi-fw pi-chart-bar",
                        items: [
                            {
                                key: "0_0",
                                label: t("components.common.appMenu.clickPreview"),
                                to: "/dashboard",
                            },
                            {
                                key: "0_1",
                                label: t("components.common.appMenu.analyticsOfAllClicks"),
                                to: "/clicks",
                            },
                            {
                                key: "0_2",
                                label: t("components.common.appMenu.topProducts"),
                                to: "/products",
                            },
                            {
                                key: "0_3",
                                label: t("components.common.appMenu.topCategories"),
                                to: "/category",
                            },
                            {
                                key: "0_4",
                                label: t("components.common.appMenu.devices"),
                                to: "/devices",
                            },
                            {
                                key: "0_5",
                                label: t("components.common.appMenu.day&Hour"),
                                to: "/activities",
                            },
                            {
                                key: "0_6",
                                label: t("components.common.appMenu.liquidity"),
                                to: "/liquidity",
                            },
                            {
                                key: "0_7",
                                label: t("components.common.appMenu.distribution"),
                                to: "/distribution",
                            },
                        ],
                    },
                    {
                        key: 2,
                        label: t("components.common.appMenu.coupons"),
                        icon: "pi pi-fw pi-tags",
                        items: [
                            {
                                key: "0_0",
                                label: "Add coupons",
                                to: "/coupons/add"
                            },
                            {
                                key: "0_1",
                                label: "Manage coupons",
                                to: "/coupons/all"
                            },
                            {
                                key: "0_1",
                                label: t('pages.coupons.faq.label'),
                                to: "/coupons/faq"
                            },
                        ]
                    },
                    {
                        key: 1,
                        label: t("components.common.appMenu.productAd"),
                        icon: "pi pi-fw pi-hashtag",
                        items: [
                            {
                                key: "0_0",
                                label: t("components.common.appMenu.productAdManager"),
                                to: "/product-ads",
                            },
                            {
                                key: "0_1",
                                label: t("components.common.appMenu.productAdInsights"),
                                to: "/product-ad-insights",
                            },
                        ],
                    },
                    {
                        key: 15,
                        label: t("components.common.appMenu.customerSupport"),
                        icon: "pi pi-fw pi-info",
                        items: [
                            {
                                key: "0_0",
                                label: t("components.common.appMenu.ticketList"),
                                to: "/ticket-list",
                            },
                            {
                                key: "0_1",
                                label: t("components.common.appMenu.newTicket"),
                                to: "/ticket-new",
                            },
                        ],
                    }
                );

                if (
                    selectedShop.value?.sf_limit_price_c !== null &&
                    selectedShop.value?.sf_is_active_c !== "Inactive"
                ) {
                    menuItems.push({
                        key: 5,
                        label: t("components.common.appMenu.shops"),
                        icon: "pi pi-fw pi-home",
                        items: [
                            {
                                key: "0_0",
                                label: t("components.common.appMenu.shopsList"),
                                to: "/shops",
                            },
                            {
                                key: "0_1",
                                label: t("components.common.appMenu.priceList"),
                                to: "/price-list",
                            },
                            {
                                key: "0_2",
                                label: t("components.common.appMenu.limitManagement"),
                                to: "/limit-management",
                            },
                        ],
                    });
                } else {
                    menuItems.push({
                        key: 5,
                        label: t("components.common.appMenu.shops"),
                        icon: "pi pi-fw pi-home",
                        items: [
                            {
                                key: "0_0",
                                label: t("components.common.appMenu.shopsList"),
                                to: "/shops",
                            },
                            {
                                key: "0_1",
                                label: t("components.common.appMenu.priceList"),
                                to: "/price-list",
                            },
                        ],
                    });
                }

                if (selectedShop?.value?.id === 1358) {
                    menuItems.push({
                        key: 1,
                        label: t("components.common.appMenu.ePonudaRecommendedBidding"),
                        icon: "pi pi-fw pi-credit-card",
                        items: [
                            {
                                key: "1_0",
                                label: t("components.common.appMenu.biddingPreview"),
                                to: "/bidding",
                            },
                            {
                                key: "1_1",
                                label: t("components.common.appMenu.biddingAnalytics"),
                                to: "/bidding/statistics",
                            },
                            {
                                key: "1_2",
                                label: t("components.common.appMenu.module"),
                                to: "/module",
                            },
                        ],
                    });
                } else {
                    menuItems.push({
                        key: 1,
                        label: t("components.common.appMenu.ePonudaRecommendedBidding"),
                        icon: "pi pi-fw pi-credit-card",
                        items: [
                            {
                                key: "1_0",
                                label: t("components.common.appMenu.biddingPreview"),
                                to: "/bidding",
                            },
                            {
                                key: "1_1",
                                label: t("components.common.appMenu.biddingAnalytics"),
                                to: "/bidding/statistics",
                            },
                        ],
                    });
                }
            }

            // Only for admins        
            if (userStore.user.role_id === 1) {
                menuItems.push({
                    key: 11,
                    label: t("components.common.appMenu.biddingOverview"),
                    icon: "pi pi-fw pi-credit-card",
                    items: [
                        {
                            key: "1_0",
                            label: t("components.common.appMenu.biddingCategoryOverview"),
                            to: "/bidding-category-overview",
                        },
                        {
                            key: "1_1",
                            label: t("components.common.appMenu.biddingSellerOverview"),
                            to: "/bidding-seller-overview",
                        },
                        {
                            key: "1_1",
                            label: t("components.common.appMenu.sellerEndBiddings"),
                            to: "/seller-end-biddings",
                        },
                    ],
                });
            }

            // Only for admins        
            if (userStore.user.role_id === 1) {
                menuItems.push({
                    key: 12,
                    label: t("components.common.appMenu.productAdOverview"),
                    icon: "pi pi-fw pi-credit-card",
                    items: [
                        {
                            key: "1_0",
                            label: t("components.common.appMenu.biddingCategoryOverview"),
                            to: "/product-ads-category-overview",
                        },
                        {
                            key: "1_1",
                            label: t("components.common.appMenu.biddingSellerOverview"),
                            to: "/product-ads-seller-overview",
                        },
                        {
                            key: "1_1",
                            label: t("components.common.appMenu.sellerEndProductAds"),
                            to: "/seller-end-product-ads",
                        },
                    ],
                });
            }

            if (userStore.user.role_id !== 3 && userStore.user.invite_users) {
                menuItems.push({
                    key: 7,
                    label: t("components.common.appMenu.members"),
                    icon: "pi pi-fw pi-users",
                    items: [
                        {
                            key: "5_0",
                            label: t("components.common.appMenu.myMembers"),
                            to: "/members",
                        },
                        {
                            key: "5_1",
                            label: t("components.common.appMenu.myInvites"),
                            to: "/invites",
                        },
                    ],
                });
            }

            if (userStore.user.role_id === 1) {
                menuItems.push({
                    key: 10,
                    label: "Api access",
                    icon: "pi pi-fw pi-key",
                    items: [
                        {
                            key: "0_0",
                            label: "Access tokens",
                            to: "/accessTokens",
                        },
                    ],
                });
            }

            return menuItems.sort((a, b) => (a.key > b.key ? 1 : -1));
        });

        const selectShop = async () => {
            await fetchClicksDataByReport();
            await fetchTableDataByReport();
            await fetchData();
            await createUserPageLog();
            if (route.name === "CouponsRead") {
                setTimeout(() => {
                    location.reload();
                }, 2000);
            }
        };

        const hideMenu = () => {
            search.value.filterValue = "";
            selectShop();
        };

        watch(selectedShop, () => {
            source.value =
                selectedShop.value?.country_locale_code === "rs"
                    ? t("pages.dashboard.sourceEponudaCom")
                    : selectedShop.value?.country_locale_code === "hr"
                    ? t("pages.dashboard.sourceShoptokHr")
                    : selectedShop.value?.country_locale_code === "si"
                    ? t("pages.dashboard.sourceShoptok")
                    : t("pages.dashboard.sourceShoptokBa");
        });

        return {
            // changeShop,
            expandedKeys,
            getShops,
            hideMenu,
            items,
            search,
            selectShop,
            selectedShop,
            shops,
            user,
        };
    },
};
</script>

<style lang="scss"></style>
